import * as angular from 'angular';
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {BillingAccountsRequests} from "./billing-accounts-requests.service";
import {BillingAlertsService} from "./billing-alerts.service";

export class BillingAccountService {

  /* @ngInject */
  constructor(private $q: IQService, private $log, private bringozLoaderService: BringozLoaderService, private billingAlertsService: BillingAlertsService, private billingAccountsRequests: BillingAccountsRequests) {
  }

  update(billingAccountId, billingAccount) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.billingAccountsRequests.update(billingAccountId, billingAccount)
      .then((res) => {
        this.billingAlertsService.updateBillingAccountSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.updateBillingAccountError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updatePreferences(billingAccountId, preferences) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.billingAccountsRequests.updatePreferences(billingAccountId, preferences)
      .then((res) => {
        this.billingAlertsService.updateBillingAccountPreferencesSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.updateBillingAccountPreferencesError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .service('billingAccountService', BillingAccountService);
